import React from "react";
import {DashboardCard} from "../../../../designSystem/components/DashboardCard";
import {Typography} from "../../../../designSystem/components/Typography";
import {InformationTable} from "../InformationTable";
import {InformationRow} from "../InformationRow";

import {timestampToDate, formatIsoDateString} from "../../../../utils/date";
import {ICase} from "../../../../types/Case";

interface ApplicationTimestampViewProps {
  caseData: ICase;
}

export const ApplicationTimestampView = ({
  caseData
}: ApplicationTimestampViewProps) => (
  <DashboardCard>
    <Typography variant="subtitle">
      案件時間戳
    </Typography>
    <InformationTable>
      {caseData.createAt &&
        <InformationRow title="申請時間" value={new Date(timestampToDate(caseData.createAt)).toLocaleString()}/>
      }
      {caseData.assignedAt &&
        <InformationRow title="派案時間" value={new Date(timestampToDate(caseData.assignedAt)).toLocaleString()}/>
      }
      {caseData.acceptedAt &&
        <InformationRow title="收案時間" value={new Date(timestampToDate(caseData.acceptedAt)).toLocaleString()}/>
      }
      {caseData.report?.contactTime &&
        <InformationRow title="聯繫病人時間" value={formatIsoDateString(caseData.report.contactTime)}/>
      }
      {caseData.report?.serviceTime &&
        <InformationRow title="到宅服務時間" value={formatIsoDateString(caseData.report.serviceTime)}/>
      }
      {caseData.report?.closureTime &&
        <InformationRow title="結案時間" value={formatIsoDateString(caseData.report.closureTime)}/>
      }
      {caseData.surveySubmittedAt &&
        <InformationRow
          title="滿意度提交時間"
          value={new Date(timestampToDate(caseData.surveySubmittedAt)).toLocaleString()}
        />
      }
    </InformationTable>
  </DashboardCard>
)
